import { ApplicationRef, ComponentRef, createComponent, Injectable, Injector } from '@angular/core';

import { NEVER, Observable } from 'rxjs';
import { catchError, map, take, tap } from 'rxjs/operators';

import { TranslateService } from '@ngx-translate/core';
import { OperatorFactory } from '../../operator-factory/services/operator-factory.service';
import { LabelPrintOverviewContainerComponent } from '../containers/label-print-overview/label-print-overview-container.component';
import { RecordListPrintOverviewComponent } from '../containers/record-list-print-overview/record-list-print-overview.component';
import { PrintLabelRequest, PrintRecordListRequest } from '../entities/print.entity';

@Injectable()
export class RecordPrintService {
    constructor(
        private injector: Injector,
        private appRef: ApplicationRef,
        private operatorFactory: OperatorFactory,
        private readonly translateService: TranslateService
    ) {}

    public printLabels(request: PrintLabelRequest[]): Observable<void> {
        const componentRef: ComponentRef<LabelPrintOverviewContainerComponent> = createComponent(
            LabelPrintOverviewContainerComponent,
            {
                environmentInjector: this.appRef.injector,
                elementInjector: this.injector
            }
        );
        componentRef.instance.records = request;
        this.appRef.attachView(componentRef.hostView);
        return componentRef.instance.printClose.pipe(
            take(1),
            map(() => {
                this.appRef.detachView(componentRef.hostView);
                componentRef.destroy();
            })
        );
    }

    public printList(printRequest: PrintRecordListRequest): Observable<void> {
        const componentRef: ComponentRef<RecordListPrintOverviewComponent> = createComponent(
            RecordListPrintOverviewComponent,
            {
                environmentInjector: this.appRef.injector,
                elementInjector: this.injector
            }
        );

        componentRef.instance.query = printRequest.query;
        if (printRequest.sort) {
            componentRef.instance.sort = printRequest.sort;
        }
        componentRef.instance.columns = printRequest.columns;
        componentRef.instance.titleTranslationKey = printRequest.titleTranslationKey;
        componentRef.instance.resultsTranslationKey = printRequest.resultsTranslationKey;
        this.appRef.attachView(componentRef.hostView);
        return componentRef.instance.closed.pipe(
            take(1),
            catchError(err => {
                console.error(err);
                return NEVER;
            }),
            tap(() => {
                this.appRef.detachView(componentRef.hostView);
                componentRef.destroy();
            }),
            this.operatorFactory.withToastUpdates({
                startedMsgKey: 'label-print.toast',
                removeOnSuccess: true
            })
        );
    }
}
